<!-- MOLECULE: DrawerHeaderExpanded.vue -->
<!-- Navigation drawer header rendered in expanded (non-rail) mode with logo, app name, and user info. -->

<script setup lang="ts">
//
// Props & Emits
//
interface Props {
  appLogoExpandedMode?: string | null;
  appName?: string;
  userName?: string;
  userEmail?: string;
}

const props = withDefaults(defineProps<Props>(), {
  appLogoExpandedMode: null,
  appName: "Iris",
  userName: "User Name",
  userEmail: "example@email.com",
});

//
// Composables
//
const computedLogoSrc = useAssetPath(
  "/app-logo-white.png",
  toRef(() => props.appLogoExpandedMode),
);
</script>

<template>
  <v-list-item class="bg-primary pa-4">
    <v-list-item-title class="d-flex align-center ga-2 mb-2">
      <v-img :src="computedLogoSrc" :width="24" :height="24" :alt="`${appName} logo`" class="flex-0-1" />
      <span class="text-h6 font-weight-bold">{{ appName }}</span>
    </v-list-item-title>

    <v-list-item-subtitle class="d-flex flex-column opacity-80">
      <span class="text-body-2 font-weight-bold">{{ userName }}</span>
      <span class="text-caption">{{ userEmail }}</span>
    </v-list-item-subtitle>
  </v-list-item>
</template>
